export default __webpack_public_path__ + "static/media/sawari-logo.4023d8ae.png";